/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Button } from "@/components/ui/button";
import { Pencil, X } from "lucide-react";
import { ErpSku } from "../user-input/erp-sku";
import { useUserInfo } from "@/global-data/use-user-info";

export const OnPageErpEdit = ({
  // header,
  value,
  searchErpSku,
  allData,
  onInlineUpdate,
  activeInlineEdit,
  setActiveInlineEdit,
}: {
  allData: any;
  header: string;
  value: string;
  activeInlineEdit: any;
  setActiveInlineEdit: any;
  searchErpSku: (prop: string) => Promise<void>;
  onInlineUpdate: (prop: string) => Promise<void>;
}) => {
  const handleUpdate = async (prop: {
    erp_sku_code: string;
    erp_sku_name: string;
    erp_uom?: string;
  }) => {
    const newData = {
      ...allData,
      erp_sku_code: prop.erp_sku_code,
      erp_sku_name: prop.erp_sku_name,
      erp_uom: prop?.erp_uom,
    };
    console.log({ newData });
    await onInlineUpdate(newData);
    setActiveInlineEdit(undefined);
  };

  const { activePermission } = useUserInfo();

  return (
    <ConditionRenderer
      condition={
        activeInlineEdit?.sku_map_id === allData?.sku_map_id &&
        allData?.sku_map_id !== undefined
      }
    >
      <span className="flex items-center justify-between">
        <div className="w-[calc(100%_-_40px)]">
          <ErpSku
            placeholder="Search erp sku"
            onChange={() => {}}
            onSearch={searchErpSku}
            value={value}
            onBlur={() => {}}
            bindLabel="erp_sku_name"
            bindValue="erp_sku_code"
            onValueChange={() => {}}
            onAllValueChange={handleUpdate}
            defaultValue={
              allData?.erp_sku_name && allData?.erp_sku_code
                ? [
                    {
                      erp_sku_name: allData?.erp_sku_name,
                      erp_sku_code: allData?.erp_sku_code,
                    },
                  ]
                : []
            }
          />
        </div>
        <Button
          onClick={() => setActiveInlineEdit(undefined)}
          size={"icon"}
          variant={"ghost"}
        >
          <X className="text-red-500" size={15} />
        </Button>
      </span>
      <span className="flex items-center justify-between">
        {value}
        {activePermission?.update ? (
          <Button
            onClick={() => setActiveInlineEdit(allData)}
            size={"icon"}
            variant={"ghost"}
          >
            <Pencil className="text-primary" size={15} />
          </Button>
        ) : null}
      </span>
    </ConditionRenderer>
  );
};
